import { useState } from "react";
import { useRecentActivities } from "../../../js/api/activity-feed/get-activities";
import { useRecentActivityFeed } from "../../recent-activity-feed";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../shared/accordion";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { ActivityFeed } from "./activity-feed";
import {
  ActivityFeedFilter,
  ACTIVITY_FEED_FILTERS,
  DEFAULT_ACTIVITY_FEED_FILTER,
} from "./activity-feed-filter";
import { useMediaQuery } from "@uidotdev/usehooks";
import { splitActivitiesByDivider } from "./split-activities-by-divider";

const ACTIVITIES_COUNT = 20;
const ACTIVITIES_DIVIDER = 5;

export const RecentActivityFeedWrapper = () => {
  const propsData = useRecentActivityFeed();
  const [feedFilter, setFeedFilter] = useState(DEFAULT_ACTIVITY_FEED_FILTER);
  const { data, isLoading, isError, isFetching } = useRecentActivities({
    itemCount: ACTIVITIES_COUNT,
    pageNumber: 1,
    beforeTimestamp: new Date().toISOString(),
    allMembers: feedFilter === ACTIVITY_FEED_FILTERS.allMembers,
  });
  const isAccordionVersion = useMediaQuery(
    "only screen and (max-width : 979px)"
  );

  const isEmpty = !isLoading && !isFetching && !data?.activityFeedsList.length;

  if (isLoading) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  const { shownData, hiddenData } = splitActivitiesByDivider(
    ACTIVITIES_DIVIDER,
    data
  );

  return (
    <>
      <ActivityFeedFilter
        label={propsData?.show}
        title={propsData?.activity}
        value={feedFilter}
        onChange={setFeedFilter}
        options={[
          {
            value: ACTIVITY_FEED_FILTERS.following,
            label: propsData?.myActivities,
          },
          {
            value: ACTIVITY_FEED_FILTERS.allMembers,
            label: propsData?.allActivities,
          },
        ]}
      />
      {isEmpty && (
        <div className="saved-colors-loading-container saved-colors-loading-container--no-top-padding">
          {propsData.emptyActivitiesMessage}
        </div>
      )}
      {!isEmpty && isAccordionVersion && (
        <>
          <Accordion
            type="single"
            collapsible
          >
            <AccordionItem value="item-1">
              <ActivityFeed
                apiData={shownData}
                contextData={propsData}
              />
              <AccordionContent>
                <ActivityFeed
                  apiData={hiddenData}
                  contextData={propsData}
                />
              </AccordionContent>
              {hiddenData && hiddenData?.activityFeedsList?.length > 0 && (
                <AccordionTrigger>
                <span className="accordion-trigger-text accordion-trigger-text--open">
                  {propsData?.showLess}
                </span>
                  <span className="accordion-trigger-text accordion-trigger-text--closed">
                  {propsData?.showMore}
                </span>
                </AccordionTrigger>
              )}
            </AccordionItem>
          </Accordion>
        </>
      )}
      {!isEmpty && !isAccordionVersion && (
        <ActivityFeed
          apiData={data}
          contextData={propsData}
        />
      )}
    </>
  );
};
